export const basename: string = process.env.REACT_APP_BASENAME ?? '';
export const nodeEnv: string = process.env.REACT_APP_NODE_ENV ?? '';
export const apiUrl: string = process.env.REACT_APP_API_URL ?? '';
